export default "__VITE_ASSET__e37c5ca1__"